import { SessionListComponent } from '../shared/components/session-list/session-list.component';
import { SessionCollectionComponent } from '../shared/components/session-collection/session-collection.component';
import { ParentMenuComponent } from './menu/parent-menu.component';
import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { CommonModule } from '@angular/common';
import { TargetBoxesModule } from '../staff/home/target-boxes.module';
import { ParentCollectComponent } from './collect/parent-collect.component';
import { ParentHomeComponent } from './home/parent-home.component';
import { ParentRoutingModule } from './parent-routing.module';
import { ParentSignInComponent } from './signin/parent-signin.component';

@NgModule({
  declarations: [
    ParentSignInComponent,
    ParentMenuComponent,
    ParentHomeComponent,
    ParentCollectComponent
  ],
  imports: [
    CommonModule,
    SessionCollectionComponent, SessionListComponent,
    SharedModule,
    ParentRoutingModule,
    TargetBoxesModule
  ]
})
export class ParentModule { }
